import { render, staticRenderFns } from "./PricingEditor2.vue?vue&type=template&id=7680956f&scoped=true&"
import script from "./PricingEditor2.vue?vue&type=script&lang=ts&"
export * from "./PricingEditor2.vue?vue&type=script&lang=ts&"
import style0 from "./PricingEditor2.vue?vue&type=style&index=0&id=7680956f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7680956f",
  null
  
)

export default component.exports